module.exports = __webpack_public_path__ + "img/goat.bf21bc70.jpeg";